var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7237 1.43239L15.9941 7.79701L23.3074 8.81741C23.4559 8.83506 23.5961 8.8937 23.7117 8.98647C23.8273 9.07923 23.9136 9.20229 23.9604 9.34126C24.0072 9.48024 24.0126 9.62938 23.976 9.77125C23.9394 9.91313 23.8623 10.0419 23.7537 10.1425L18.4656 15.0939L19.7145 22.0899C19.7375 22.2345 19.7188 22.3825 19.6607 22.5174C19.6027 22.6522 19.5074 22.7686 19.3856 22.8536C19.2638 22.9385 19.1203 22.9886 18.9711 22.9983C18.8219 23.008 18.6728 22.9768 18.5407 22.9084L11.9999 19.605L5.45918 22.9084C5.327 22.9768 5.17797 23.008 5.02876 22.9983C4.87955 22.9886 4.73602 22.9385 4.61423 22.8536C4.49244 22.7686 4.39718 22.6522 4.33909 22.5174C4.281 22.3825 4.26238 22.2345 4.2853 22.0899L5.53419 15.0939L0.242347 10.1388C0.134797 10.0378 0.0587307 9.90903 0.0229862 9.76742C-0.0127584 9.62582 -0.0067142 9.47719 0.0404165 9.33881C0.0875472 9.20043 0.17383 9.07798 0.28924 8.98569C0.40465 8.89339 0.544449 8.83504 0.692397 8.81741L8.00572 7.79701L11.2761 1.43239C11.3445 1.30217 11.4482 1.19292 11.5759 1.11664C11.7036 1.04036 11.8503 1 11.9999 1C12.1495 1 12.2962 1.04036 12.4239 1.11664C12.5516 1.19292 12.6554 1.30217 12.7237 1.43239Z",
    fill: "#FFDA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.2895 10.5425C13.2888 11.0931 8.41329 14.7306 7.1794 19.4508H7.16065L8.08325 14.2754L4.16406 10.6049L9.57967 9.84515L12.0024 5.16528L14.4252 9.87451L19.2895 10.5425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNew);
export default __webpack_public_path__ + "static/media/star-new.ea2ed93d.svg";
export { ForwardRef as ReactComponent };